/**
 * Phase 2C — SEO Tools (Convertitori & Quanto Vale)
 * 4 micro-tool pages with high-intent keywords.
 */

export type StrumentoVariant =
  | 'once-grammi'
  | 'grammi-euro-oro'
  | 'quanto-vale-1g'
  | 'quanto-vale-18kt';

export interface StrumentoMeta {
  slug: string;
  path: string;
  variant: StrumentoVariant;
  h1: string;
  titleTag: string;
  metaDesc: string;
  intro: string;
}

export const STRUMENTI_ORO: Record<string, StrumentoMeta> = {
  'convertitore-once-grammi': {
    slug: 'convertitore-once-grammi',
    path: '/convertitore-once-grammi',
    variant: 'once-grammi',
    h1: 'Convertitore Once Troy → Grammi (Oro)',
    titleTag: 'Convertitore Once Grammi Oro | 1 oz = 31,1035 g | Gildy',
    metaDesc:
      "Converti once troy (oz t) in grammi per oro e argento. 1 oz = 31,1035 g. Calcolatore live con prezzo spot LBMA aggiornato in tempo reale.",
    intro:
      "L'oncia troy (oz t) è l'unità di misura internazionale per i metalli preziosi: 1 oncia equivale a 31,1034768 grammi. Converti rapidamente fra le due unità e visualizza il valore in euro al prezzo spot corrente.",
  },
  'convertitore-grammi-euro-oro': {
    slug: 'convertitore-grammi-euro-oro',
    path: '/convertitore-grammi-euro-oro',
    variant: 'grammi-euro-oro',
    h1: 'Convertitore Grammi → Euro Oro',
    titleTag: 'Convertitore Grammi Euro Oro | Calcola €/g Live | Gildy',
    metaDesc:
      "Da grammi a euro: calcola il valore del tuo oro per ogni caratura (24KT, 22KT, 18KT, 14KT, 9KT). Prezzo spot LBMA aggiornato live.",
    intro:
      "Inserisci i grammi del tuo oro, scegli la caratura e ottieni immediatamente il valore in euro. Il calcolo usa il prezzo spot dell'oro aggiornato in tempo reale.",
  },
  'quanto-vale-1-grammo-oro': {
    slug: 'quanto-vale-1-grammo-oro',
    path: '/quanto-vale-1-grammo-oro',
    variant: 'quanto-vale-1g',
    h1: 'Quanto Vale 1 Grammo di Oro Oggi',
    titleTag: 'Quanto Vale 1 Grammo di Oro Oggi | Prezzo Live €/g | Gildy',
    metaDesc:
      "Quanto vale 1 grammo d'oro oggi? Prezzo aggiornato in tempo reale per 24KT, 22KT, 18KT, 14KT e 9KT. Quotazione spot LBMA in euro.",
    intro:
      "Il valore di 1 grammo d'oro dipende dalla caratura e dalla quotazione internazionale del giorno. Qui trovi il prezzo live aggiornato ogni 30 secondi per tutte le purezze.",
  },
  'quanto-vale-oro-18kt': {
    slug: 'quanto-vale-oro-18kt',
    path: '/quanto-vale-oro-18kt',
    variant: 'quanto-vale-18kt',
    h1: "Quanto Vale l'Oro 18KT (750‰) Oggi",
    titleTag: 'Quanto Vale Oro 18KT Oggi | Prezzo 750‰ Live | Gildy',
    metaDesc:
      "Quanto vale l'oro 18 carati (750‰) oggi? Prezzo €/grammo aggiornato in tempo reale. Confronta con i compro oro vicino a te su Gildy.",
    intro:
      "L'oro 18 carati (750 millesimi) è la lega più diffusa in gioielleria classica: 75% oro fino + 25% altri metalli. Il suo valore al grammo è pari al prezzo spot 24KT moltiplicato per 0,750.",
  },
};

export const STRUMENTI_SLUGS = Object.keys(STRUMENTI_ORO);
